import { AxiosResponse } from "axios";

import { IAllergy } from "../@types/Allergy";
import { api } from "./api";

export const allergyService = {
  async searchAllergies(
    search: string,
    limit = 50
  ): Promise<AxiosResponse<IAllergy[]>> {
    return api.get("/Shared/Allergies", { params: { search, limit } });
  },
};
